// extracted by mini-css-extract-plugin
export default {"header":"Chat_header__36DEL","container":"Chat_container__hFJSw","content":"Chat_content__Ubm5k","overlayDisabled":"Chat_overlayDisabled__thcj4","chat":"Chat_chat__Wg5NV"};